export default __webpack_public_path__ + "static/media/pixel-hero-back.044f87ae.gif";